import { marqueeItems } from "@/data/site";

export default function Marquee() {
  const row = [...marqueeItems, ...marqueeItems, ...marqueeItems];
  return (
    <div className="overflow-hidden border-y border-[#0B1F3A]/10 bg-white py-5" aria-hidden="true" data-testid="editorial-marquee">
      <div className="ic-marquee-track flex w-max items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="whitespace-nowrap font-display text-sm font-semibold uppercase tracking-[0.28em] text-[#0B1F3A]/75">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rounded-full bg-[#C9A227]/50" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
